import {getENV} from "../utils";
import {BASE_PARAMS} from "../config";

export const UploadMixin = {
  data() {
    return {
      API_URL: getENV().upload,
      UPLOAD_PARAMS: {...BASE_PARAMS, service: 'smarthos.system.file.upload'},
      UPLOAD_HEADERS: {
        sign: 'test'
      },
      fileType: 'TEXT'
    }
  },
  created() {

  },
  methods: {
    uploadOnError(error, file, fileList) {
      Log('error', error, file, fileList);
      this.$message.error('上传失败');
    },
    onSuccess(response) {
      if (response && response.code !== '0') this.$message.error(response.msg);
    },
    onExceed() {
      this.$message.error('最多可上传9张图片，支持jpg、png、gif、bmp、PDF格式。');
    },
    beforeUpload2(file) {
      let fileName = file.name;
      let pos = fileName.lastIndexOf(".");
      let lastName = fileName.substring(pos + 1, fileName.length);
      let type = file.type || lastName;
      let has = ['application/pdf', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/zip', 'rar'].includes(type);

      if (!has) {
        this.$message.error('文件格式不正确');
        return false;
      }
    }
  },
}
